import { useCallback, useEffect, useState } from "react";

import ProfileSettingForm from "../../components/ProfileSettingForm";
import { useBreadcrumbs } from "../../contexts/BreadcrumbContext";
import { getMe } from "../../services/user.service";

const initialFormData = {
  email: "",
  name: "",
  mobile_no: "",
  image: "",
};

export default function ProfileSetting() {
  const { setBreadcrumbs } = useBreadcrumbs();

  useEffect(() => {
    setBreadcrumbs([]);
  }, [setBreadcrumbs]);

  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState(initialFormData);

  const fetchMe = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await getMe();
      // setData(response);
      if (response) {
        setFormData({
          email: response?.email,
          name: response?.name,
          mobile_no: response?.mobile_no,
          image: response?.image || "",
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  return (
    <>
      {isLoading ? (
        <></>
      ) : (
        <ProfileSettingForm formData={formData} mutate={fetchMe} />
      )}
    </>
  );
}
